<template>
  <vx-card v-show="isCardActiveLocal" title="Upload Task Details" class="mb-4">
    <div class="vx-row">
      <div class="vx-col w-full">
        <table>
          <tr><td><p>Module Name:</p></td><td><p style="font-weight: 700">{{ uploadTask.moduleName }}</p></td></tr>
          <tr><td><p>Module Description:</p></td><td><p style="font-weight: 700">{{ uploadTask.moduleDescription }}</p></td></tr>
          <tr><td><p>Task Display ID:</p></td><td><p style="font-weight: 700">{{ uploadTask.taskDisplayId }}</p></td></tr>
          <tr><td><p>Task Name:</p></td><td><p style="font-weight: 700">{{ uploadTask.taskName }}</p></td></tr>
          <tr> 
            <td><p>Student Fullname :&emsp;</p></td>  
            <td><p style="font-weight: 700">{{ ' ' + uploadTask.fullname }}</p></td>
          </tr>
          <tr><td><p>Allow Multiple Uploads:</p></td><td><p :style="{ 'color': setColor(uploadTask.allowMultiple), 'font-weight': 700 }">{{ uploadTask.allowMultiple ? 'Yes' : 'No' }}</p></td></tr>
          <tr><td><p>Allow Audio:</p></td><td><p :style="{ 'color': setColor(uploadTask.allowAudio), 'font-weight': 700 }">{{ uploadTask.allowAudio ? 'Yes' : 'No' }}</p></td></tr>
          <tr><td><p>Allow Documents:</p></td><td><p :style="{ 'color': setColor(uploadTask.allowDocument), 'font-weight': 700 }">{{ uploadTask.allowDocument ? 'Yes' : 'No' }}</p></td></tr>
          <tr><td><p>Allow Images:</p></td><td><p :style="{ 'color': setColor(uploadTask.allowImage), 'font-weight': 700 }">{{ uploadTask.allowImage ? 'Yes' : 'No' }}</p></td></tr>
          <tr><td><p>Allow Videos:</p></td><td><p :style="{ 'color': setColor(uploadTask.allowVideo), 'font-weight': 700 }">{{ uploadTask.allowVideo ? 'Yes' : 'No' }}</p></td></tr>
        </table>
      </div>
    </div>
    <vs-divider></vs-divider>
    <vs-table ref="uploadsTable" single max-items="15" pagination :data="uploadTask.uploadedFiles">
      <div slot="header" class="mt-4 mb-3 flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <h5> Student Uploaded Files</h5>
        </div>
      </div>

      <template slot-scope="{data}">
        <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data">
          <vs-td>
            <img :src="setFileThumb(file)" width=30px class="product-img" />
          </vs-td>
          <vs-td>
            <p class="product-name font-medium">{{ file.substring(file.lastIndexOf('/') + 1) }}</p>
          </vs-td>
          <vs-td>
            <vs-button color="success" class="float-right" type="filled" icon-pack="feather" icon="icon-download" @click.stop="downloadFile(file)"></vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>

  import vSelect from 'vue-select'
  import vueFilePond from 'vue-filepond';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);
 
  export default {
    components: { 
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      uploadTask: {
        type: Object,
        required: false
      }
    },
    data() {
      return {
        uploadTaskTitle: "",
        uploadTaskContent: ""
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          var self=this;
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.uploadTask){

          }else{
            self.initValues();
          }
        }
      }
    },
    methods: {
      strip(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      },
      setColor(val) {
        if(val){
          return '#00cc00';
        }
        else{
          return 'orange';
        }
      },
      open(file){
        window.open(file);
      },
      setFileThumb(url) {
        var ext = url.substring(url.lastIndexOf('.') + 1);
        if (ext.includes('mp3'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/music.jpg";
        else if (ext.includes('jpg') || ext.includes('jpeg') || ext.includes('png') || ext.includes('gif') || ext.includes('PNG'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/image.png";
        else if (ext.includes('doc') || ext.includes('xls') || ext.includes('pdf') || ext.includes('ppt') || ext.includes('txt') || ext.includes('rtf'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/document.png";
        else if (ext.includes('mp4') || ext.includes('wmv') || ext.includes('mov') || ext.includes('webm') || ext.includes('x-matroska') || ext.includes('mkv'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/video.png";
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {
        
        this.errors.clear();
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
      downloadFile(file){
        window.open(file, "_blank");
      },
    },
    mounted() {
      if(this.uploadTask){
        this.uploadTaskTitle = this.strip(this.uploadTask.title);
        this.uploadTaskContent = this.strip(this.uploadTask.content);
      }
    }
  }

</script>

<style lang="scss">

</style>
